import { getAccessToken } from '@/shared/utils/access-token-storage';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  accessToken: string | null;
  userId: string;
  data: any;
}

const initialState: AuthState = {
  accessToken: getAccessToken() ?? null,
  userId: '',
  data: {}
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | null>) => {
      state.accessToken = action.payload;
    },
    setCurrentUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setCurrentUserData: (state, action: any) => {
      state.data = action.payload;
    }
  }
});

export const { setToken, setCurrentUserId, setCurrentUserData } = authSlice.actions;
export default authSlice.reducer;

